(function (window, document) {
    'use strict';

    var hash = '#open-cookie-settings';
    var queryParameter = 'open-cookie-settings';

    function openCookieSettings() {
        console.log('Cookie settings opened');
        if (window.CookieConsent && typeof window.CookieConsent.renew === 'function') {
            window.CookieConsent.renew();
        }
    }

    function isCookieSettingsUrl(url) {
        return url.hash === hash || url.searchParams.get(queryParameter) === 'true';
    }

    function normalizePathname(pathname) {
        if (pathname.length <= 1) {
            return pathname;
        }

        return pathname.replace(/\/+$/, '');
    }

    function getUrlWithoutMarker(url) {
        var normalizedUrl = new URL(url.toString());

        if (normalizedUrl.hash === hash) {
            normalizedUrl.hash = '';
        }

        if (normalizedUrl.searchParams.get(queryParameter) === 'true') {
            normalizedUrl.searchParams.delete(queryParameter);
        }

        normalizedUrl.pathname = normalizePathname(normalizedUrl.pathname);

        return normalizedUrl.toString();
    }

    function removeMarkerFromCurrentUrl() {
        var currentUrl = new URL(window.location.href);
        var updatedUrl = getUrlWithoutMarker(currentUrl);

        if (updatedUrl !== currentUrl.toString()) {
            history.replaceState(null, '', updatedUrl);
        }
    }

    document.addEventListener('click', function (evt) {
        if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
            return;
        }

        if (!evt.target || typeof evt.target.closest !== 'function') {
            return;
        }

        var link = evt.target.closest('a');
        if (!link || !link.href) {
            return;
        }

        var clickedUrl = new URL(link.href, window.location.origin);
        var currentUrl = new URL(window.location.href);

        if (!isCookieSettingsUrl(clickedUrl) || getUrlWithoutMarker(clickedUrl) !== getUrlWithoutMarker(currentUrl)) {
            return;
        }

        evt.preventDefault();
        openCookieSettings();
    });

    (function openCookieSettingsFromCurrentUrl() {
        var currentUrl = new URL(window.location.href);

        if (!isCookieSettingsUrl(currentUrl)) {
            return;
        }

        setTimeout(() => {
            openCookieSettings();
            removeMarkerFromCurrentUrl();
        }, 500);
    })();
})(window, document);
